import {
  FiActivity,
  FiCode,
  FiLayout,
  FiPackage,
} from 'react-icons/fi';
import type { ProductIconKey } from '@/config/products';

export const PRODUCT_ICON_COMPONENTS: Record<ProductIconKey, typeof FiLayout> = {
  layout: FiLayout,
  code: FiCode,
  package: FiPackage,
  pulse: FiActivity,
};

export function getProductIconComponent(iconKey: ProductIconKey) {
  return PRODUCT_ICON_COMPONENTS[iconKey];
}
